import nanoScroller from '@global/vendors/jquery.nanoscroller.min';
import Vue from 'vue';
import modal from 'bootstrap/js/dist/modal';
import AlertDialog from '@global/helpers/alertDialog';
import streamCart from '@page/common/js/streamCart';
import messageBox from '@global/helpers/messageBox';
import validate from '@global/vendors/jquery.validate.min';
import Collapse from 'bootstrap/js/dist/collapse';
import store from '@global/components/store/index';
import utmDetect from '@global/helpers/utmDetect';
import cookieMethod from '@global/helpers/cookieMethod';
import NewImage from '@global/components/global/image';
import { createNamespacedHelpers } from 'vuex';
import $ from 'jquery';
import { fireSearchListEvent } from '@global/gtm/shopList/shopListView';
import fireSearchEvent from '@global/gtm/search';

import globalCtrl from './globalCtrl';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('miniCartModule');
const axios = require('axios');

global.$ = global.jQuery = require('jquery'); // fix can't use JQ in inline script
require('sticky-kit/dist/sticky-kit');

// 全域方法前後端使用
window.AlertDialog = AlertDialog;
window.messageBox = messageBox;
window.Vue = Vue;
globalCtrl();

if ($('#app-mini-cart').length > 0) {
  window.appNotificationCart = new Vue({
    el: '#app-mini-cart',
    store,
    components: { NewImage },
    computed: {
      ...mapState([
        'totalCount',
        'generalCount',
        'refrigerationCount',
        'freezingCount',
        'dataIsLoad',
        'generalMarketProducts',
        'refrigerationMarketProducts',
        'freezingMarketProducts',
        'count',
        'hotSearch',
        'hotLoad',
      ]),
      ...mapGetters(['isOnlyOneTemp']),
    },
    watch: {
      hotLoad(value) {
        if (value && window.location.pathname.includes('search')) {
          fireSearchListEvent(this.hotSearch);
        }
      },
    },
    created() {
      this.getCartInfo();
      this.getHotSearch();
    },
    methods: {
      ...mapActions(['getCartInfo', 'getHotSearch']),
      customCount(count) {
        if (count < 10) {
          return `0${count.toString()}`;
        }
        return count.toString();
      },
      goSearch(item) {
        window.location.href = `/search?Keyword=${item}`;
        fireSearchEvent({
          isHotSearch: true,
          keyword: item,
        });
      },
      goInputSearch() {
        if ($('#global-search').val().length !== 0) {
          window.location.href = `/search?Keyword=${$('#global-search').val()}`;
          fireSearchEvent({
            isHotSearch: false,
            keyword: $('#global-search').val(),
          });
        }
      },
    },
  });
}

// 電子報
window.RecordNewsletter = function RecordNewsletter() {
  $.ajax({
    type: 'POST',
    url: '/api/v1/Subscribe/Apply',
    dataType: 'json',
    data: { Email: $('#input-newsletter').val() },
    xhrFields: {
      withCredentials: false,
    },
    error() {
      AlertDialog.alert('系統發生錯誤，請稍後再試');
    },
    success(res) {
      AlertDialog.alert(res.Message);
    },
  });
};

if ($('.btn-live-cart').length !== 0) streamCart();

// KOL UTM SETTING
function KolUtmSetting() {
  let cookieName = 'kol_utm';
  let kolUtmStr = utmDetect();
  // if (kolUtmStr!==null)
  if (kolUtmStr !== null) {
    cookieMethod.setCookie(cookieName, kolUtmStr, 1);
  }
}

KolUtmSetting();

if (window.matchMedia('(max-width: 1024px)').matches) {
  setTimeout(function () {
    let w = $('.footer__slogan > span').width();
    $('.footer__menu, .footer__contact, .footer__followus').width(w);
  }, 100);
}

$('.secnav-right__search').click(function (e) {
  e.preventDefault();
  $('.search-form').addClass('open');
  $('.secnav-right__cancel').css('display', 'block');
  $('.secnav-right__search').css('display', 'none');
  $('.secnav-right__mypazzo').css('display', 'none');
  $('.secnav-right__bag').css('display', 'none');
  $('.secnav-right__burger').css('display', 'none');
  $('#global-search').get(0).focus();
});

$('.secnav-right__burger').click(function (e) {
  e.preventDefault();
  $('.sidebar').addClass('active');
  $('.secnav-right__cancel').css('display', 'block');
  $('.secnav-right__search').css('display', 'none');
  $('.secnav-right__mypazzo').css('display', 'none');
  $('.secnav-right__bag').css('display', 'none');
  $('.secnav-right__burger').css('display', 'none');
});

$('.secnav-right__cancel').click(function (e) {
  e.preventDefault();
  $('.sidebar').removeClass('active');
  $('.search-form').removeClass('open');
  $('.secnav-right__cancel').css('display', 'none');
  $('.secnav-right__search').css('display', 'block');
  $('.secnav-right__mypazzo').css('display', 'block');
  $('.secnav-right__bag').css('display', 'block');
  $('.secnav-right__burger').css('display', 'block');
});
